import api from '../../lib/api';
import { DisplayGroupBreakdownType } from '../../constants';

export default {
  namespaced: true,

  state: {
    mapFilterLoading: false,
    mapFilterData: null,
    sliderContext: null,
    sliderValue: 0,
  },

  getters: {
    sliderContext(state, _getters, _rootState, rootGetters) {
      const breakdonwSlug = DisplayGroupBreakdownType.MAP;
      const breakdown = rootGetters['breakdown/breakdownById'](breakdonwSlug);
      const { slider } = breakdown;

      if (!slider) return undefined;
      return state.sliderContext || slider.options[0];
    },
  },

  actions: {
    async fetchMapFilterData({ commit, rootGetters, rootState, state }) {
      if (!state.sliderContext) {
        return;
      }

      commit('setLoading', true);

      const breakdonwSlug = DisplayGroupBreakdownType.MAP;

      // TODO: Redo the filter to use the state and not the router
      const allowedFilters = rootGetters['breakdown/filtersByBreakdownId'](
        breakdonwSlug,
      ).map((filter) => filter.name);

      const filteredArgs = Object.keys(rootState.breakdown.query.args).filter(
        (item) => {
          return allowedFilters.includes(item);
        },
      );

      const args = filteredArgs.reduce((last, key) => {
        const obj = { ...last };
        obj[key] = [rootState.breakdown.query.args[key]];
        return obj;
      }, {});

      const { columnName, context } = state.sliderContext;

      // Add map slider context to request filters.
      const [contextField, contextValue] = context ? context.split(':') : [];
      if (contextField && contextValue) {
        args[contextField] = [contextValue];
      }

      const { year } = rootGetters['breakdown/contextByBreakdownId'](
        breakdonwSlug,
      );
      if (year) {
        args.year = [year];
      }

      // Add currently selected geo type to request filters.
      const { geoType } = rootState.breakdown;
      args.geo_type = [geoType];
      args.geo_code_long = rootState.breakdown.geos;
      const params = {
        indicator_id: rootState.indicator.indicatorId,
        display_id: rootState.breakdown.query.breakdown.slug,
        datasetName: rootState.breakdown.query.datasetName,
        displayRev: rootState.breakdown.query.displayRev,
        args,
        fields: ['geo_code_long', columnName],
      };

      const data = await api.fetchData(params);
      if (data && data.results) {
        const mapFilterData = data.results.reduce((last, d) => {
          const obj = last;
          obj[d.geo_code_long] = d[columnName];
          return obj;
        }, {});
        commit('setMapFilters', { mapFilterData });
        commit('setLoading', false);
      }
    },

    setSliderContext: ({ commit, dispatch }, { context }) => {
      commit('setSliderContext', context);
      dispatch('fetchMapFilterData');
    },

    setSliderValue: ({ commit }, { value }) => {
      commit('setSliderValue', value);
    },
  },

  /* eslint-disable no-param-reassign */
  mutations: {
    setLoading: (state, loading) => {
      state.mapFilterLoading = loading;
    },

    setMapFilters: (state, { mapFilterData }) => {
      state.mapFilterData = mapFilterData;
    },

    setSliderContext: (state, context) => {
      state.sliderContext = context;
    },

    setSliderValue: (state, value) => {
      state.sliderValue = value;
    },
  },
};
